export default ["#40E385","#4B9CE3","#A365E6","#E3C334","#40E3D8"]
